import { render, staticRenderFns } from "./RtcGroupVideo.vue?vue&type=template&id=623452e2"
import script from "./RtcGroupVideo.vue?vue&type=script&lang=js"
export * from "./RtcGroupVideo.vue?vue&type=script&lang=js"
import style0 from "./RtcGroupVideo.vue?vue&type=style&index=0&id=623452e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports